import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _24mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"24mp"} ref={ref}/>
});

_24mpIcon.displayName = "_24mpIcon";
